import common from "../../components/style.css";
import style from './style.css';
import { useEffect, useState } from "preact/hooks";
import { rpc } from "../../common/api";
import { getSubdomain, validEmail } from "../../common/helpers";
import NotEnabled from "../../components/not-enabled";

const emptyValidateState = { problem: false, didYouMean: "" };

const Subscribe = () => {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [state, setState] = useState({});
  const [success, setSuccess] = useState(false);
  const [validate, setValidate] = useState(emptyValidateState);
  const [serverError, setServerError] = useState("");

  const [errors, setErrors] = useState({
    familyName: "",
    givenName: "",
    email: "",
  });

  const [givenName, setGivenName] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(async () => {
    const subdomain = getSubdomain();
    const result = await rpc("getSubscribePage", { subdomain });
    setState({
      subdomain,
      ...state,
      ...result,
    });
    setLoading(false);
  }, []);

  if (loading) {
    return <div id={common.loading}>
      <img id={common.logo} alt="" src={"https://epistlesubscribe.epistle.org/assets/images/logo.png"}/>
    </div>;
  }

  useEffect(() => {
    setValidate(emptyValidateState);
  }, [email]);

  const setEmailAndSubmit = async (email) => {
    setEmail(email);
    return submit({ email, ignoreDidYouMean: true });
  }

  const submit = async ({ email, ignoreDidYouMean }) => {
    if (submitting) return;

    setValidate(emptyValidateState);

    setServerError("");

    const err = {};

    if (givenName.trim() === "") {
      err.givenName = "First name is required";
    }

    if (familyName.trim() === "") {
      err.familyName = "Last name is required";
    }

    if (email === "") {
      err.email = "Email is required";
    } else if (!validEmail(email)) {
      err.email = "Valid email is required";
    }

    setErrors(err);

    if (Object.keys(err).length > 0) {
      setSubmitting(false);
      return;
    }

    setSubmitting(true);

    try {
      const result = await rpc("initDoubleOptIn", {
        ignoreDidYouMean,
        instanceId: state.id,
        givenName: givenName.trim(),
        familyName: familyName.trim(),
        email: email.trim().toLowerCase(),
      });

      if (result.problem) {
        setValidate(result);
      } else {
        setSuccess(true);
      }
    } catch (e) {
      console.error(e);
      setServerError("An unexpected error has occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const validateGivenName = () => {
    if (givenName.trim() === "") return;
    return setError("givenName", "");
  }

  const validateFamilyName = () => {
    if (familyName.trim() === "") return;
    return setError("familyName", "");
  }

  const validateEmail = () => {
    if (!validEmail(email)) return;
    return setError("email", "");
  }

  const setError = (field, message) => {
    const e = {
      ...errors,
      [field]: message,
    };
    setErrors(e);
  }

  const inputClasses = (error) => {
    return (error ? [style["input"], style["input-error"]] : [style["input"]]).join(" ");
  }

  if (state.code === "notfound") {
    return <NotEnabled/>
  }

  if (state.code === "notenabled") {
    return <NotEnabled/>
  }

  return (
    <div id={style.home}>
      <header id={style.header}>
        <div id={style['header-inner']}>
          <h1 id={style["site-title"]}>{state.title}</h1>
          {state.tagline ? <p id={style.tagline}>{state.tagline}</p> : null}
          <SitePicture url={state.mainImage} title={state.title}/>
        </div>
      </header>
      {success ? <Success title={state.title}/> :
        <SubscribeForm
          title={state.title}
          familyName={familyName}
          givenName={givenName}
          email={email}
          errors={errors}
          submit={submit}
          submitting={submitting}
          setEmailAndSubmit={setEmailAndSubmit}
          setGivenName={setGivenName}
          validateGivenName={validateGivenName}
          setFamilyName={setFamilyName}
          validateFamilyName={validateFamilyName}
          setEmail={setEmail}
          validateEmail={validateEmail}
          serverError={serverError}
          validate={validate}
          subdomain={state.subdomain}
        />}
      <img id={style.logo} src={"https://epistlesubscribe.epistle.org/assets/images/logo.png"} alt=""/>
    </div>
  );
};

function Success({ title }) {
  return <div id={style.success}>
    <h1 id={style["success-title"]}>Please Check Your Email</h1>
    <p id={style["success-message"]}>We just sent you a <b>confirmation email</b>. Please check your email
      to finish subscribing.</p>
    <p id={style["success-sub-message"]}>If you happen find this email in your spam or promotions
      folder, move it to your inbox or mark it as &quot;not spam&quot; so future messages from {title} don&apos;t go
      there.</p>
  </div>
}

function SubscribeForm({
                         title,
                         familyName,
                         givenName,
                         email,
                         errors,
                         submit,
                         submitting,
                         setEmailAndSubmit,
                         setGivenName,
                         validateGivenName,
                         setFamilyName,
                         validateFamilyName,
                         setEmail,
                         validateEmail,
                         serverError,
                         validate,
                         subdomain,
                       }) {
  return <form id={style.form} onSubmit={(e) => {
    e.preventDefault();
    submit({ email }).catch(console.error);
  }}>
    <h1 id={style["subscribe-title"]}>Subscribe to updates</h1>
    {serverError ? <div class={style["server-error"]}>{serverError}</div> : null}
    <Input
      label="First Name"
      error={errors.givenName}
      onChange={setGivenName}
      value={givenName}
      validate={validateGivenName}
    />
    <Input
      label="Last Name"
      error={errors.familyName}
      onChange={setFamilyName}
      value={familyName}
      validate={validateFamilyName}
    />
    <Input
      label="Email"
      error={errors.email}
      onChange={(value) => {
        setEmail(value.replace(/\s/g, ''));
      }}
      value={email}
      validate={validateEmail}
    />
    <Validation validate={validate} submit={submit} setEmailAndSubmit={setEmailAndSubmit} email={email}
                subdomain={subdomain}/>
    <div class={style["input-container"]}>
      <button type="submit" className={common.button}>
        {submitting ?
          <div class={common["button-loader-container"]}>
            <img alt="Submit" className={common["button-loader"]}
                 src={"https://epistlesubscribe.epistle.org/assets/images/button-loader.gif"}/>
          </div> :
          <span class={common["button-label"]}>Subscribe</span>}
      </button>
    </div>
  </form>
}

function Validation({ validate, setEmailAndSubmit, submit, email, subdomain }) {
  if (!validate || !validate.problem) return null;

  if (validate.didYouMean) {
    return <div class={style["validation-container"]}>
      <div class={style["validate-did-you-mean"]}>Did you mean <b>{validate.didYouMean}</b>?</div>
      <div class={style["validate-actions"]}>
        <a class={style["validate-button"]} onClick={() => setEmailAndSubmit(validate.didYouMean)}>Yes</a>
        <a class={style["validate-button"]} onClick={() => submit({ email, ignoreDidYouMean: true })}>No</a>
      </div>
    </div>;
  }

  return <div class={style["validation-container"]}>
    <div class={style["validate-unknown"]}>We were unable to validate this email address 😞<br/>Please send an email
      to <b>{subdomain}@subscribe.epistle.org</b> from <b>{email}</b> and our system will respond
      immediately with an email allowing you to subscribe.
    </div>
  </div>;
}

function Input({ label, error, onChange, validate, value }) {
  const inputClasses = (error) => {
    return (error ? [style["input"], style["input-error"]] : [style["input"]]).join(" ");
  }

  return <div class={style["input-container"]}>
    <div class={style["label-container"]}>
      <label className={style["input-label"]}>{label}</label>
      {error ? <span class={style["error-label"]}>{error}</span> : null}
    </div>
    <input type="text"
           value={value}
           className={inputClasses(error)}
           onChange={(e) => onChange(e.target.value)}
           onBlur={() => validate()}
           onKeyUp={(e) => onChange(e.target.value)}
    />
  </div>
}

function SitePicture({ title, url }) {
  if (!url) return null;

  return (
    <div id={style['site-picture']}>
      <img alt={title}
           src={url + "?w=440&h=300&fit=crop&crop=faces&dpr=2&q=50&auto=format"}/>
    </div>
  );
}


export default Subscribe;
